import { ConfigColumnMap } from '../domainObjects/configColumnMap';
import DatabaseType, { DataConnectorType, DataConnector, FileDataConnectorInfo, DatabaseConnectorInfo, ExcelDataConnector, FeatherDataConnectorInfo, OracleDataConnectorInfo, MySqlDataConnectorInfo, ParaquetDataConnectorInfo } from '../domainObjects/dataConnector';
import { DataSourceType } from '../domainObjects/dataSourceType';

export class GetColumnsRequest {
    organizationId: number;
    dataSourceType: DataSourceType;
    dataConnectorType: DataConnectorType;
    databaseType?: DatabaseType;
    dataConnector: DataConnector;
    isAutoMapApplied: boolean = false;
    isClearMapButtonClicked: boolean = false;
    ingestConfigGUID: string = "";
    selectedIngestFarmGUID: string = "";
    mapLibraryType: string = "";
    excelTurboMode?:boolean = true;
    isMultiTabIngest?: boolean = false;
    configMappedCols?: ConfigColumnMap[] = [];
    targetDataFarm?: number = 0;
  
    static newExcelConnectorColumnRequest(
      connector: ExcelDataConnector,
      dataSourceType: DataSourceType,
      organizationId: number,
      excelTurboMode:boolean,
      isMultiTabIngest:boolean, configMappedCols: ConfigColumnMap[], targetDataFarm: number, isAutoMapApplied: boolean, isClearMapButtonClicked: boolean, ingestConfigGUID: string, selectedIngestFarmGUID: string, mapLibraryType: string): GetColumnsRequest {
      const request = new GetColumnsRequest();
      request.organizationId = organizationId;
      request.dataConnector = connector;
      request.dataConnectorType = DataConnectorType.Excel;
      request.dataSourceType = dataSourceType;
      request.excelTurboMode = excelTurboMode;
      request.isMultiTabIngest = isMultiTabIngest;
      request.configMappedCols = configMappedCols;
      request.targetDataFarm = targetDataFarm;
      request.isAutoMapApplied = isAutoMapApplied;
      request.isClearMapButtonClicked = isClearMapButtonClicked;
      request.ingestConfigGUID = ingestConfigGUID;
      request.selectedIngestFarmGUID = selectedIngestFarmGUID;
      request.mapLibraryType = mapLibraryType;
      return request;
    }
  
    static newFeatherConnectorColumnRequest(
      featherConnector: FeatherDataConnectorInfo,
      dataSourceType: DataSourceType,
      organizationId: number, configMappedCols: ConfigColumnMap[], targetDataFarm: number, isAutoMapApplied: boolean, isClearMapButtonClicked: boolean, ingestConfigGUID: string, selectedIngestFarmGUID: string, mapLibraryType: string): GetColumnsRequest {
      const request = new GetColumnsRequest();
      request.organizationId = organizationId;
      request.dataConnector = featherConnector;
      request.dataConnectorType = DataConnectorType.Feather;
      request.dataSourceType = dataSourceType;
      request.configMappedCols = configMappedCols;
      request.targetDataFarm = targetDataFarm;
      request.isAutoMapApplied = isAutoMapApplied;
      request.isClearMapButtonClicked = isClearMapButtonClicked;
      request.ingestConfigGUID = ingestConfigGUID;
      request.selectedIngestFarmGUID = selectedIngestFarmGUID;
      request.mapLibraryType = mapLibraryType;
      
      return request;
    }
    static newParaquetConnectorColumnRequest(
      paraquetConnector: ParaquetDataConnectorInfo,
      dataSourceType: DataSourceType,
      organizationId: number, configMappedCols: ConfigColumnMap[], targetDataFarm: number, isAutoMapApplied: boolean, isClearMapButtonClicked: boolean, ingestConfigGUID: string, selectedIngestFarmGUID: string, mapLibraryType: string): GetColumnsRequest {
      const request = new GetColumnsRequest();
      request.organizationId = organizationId;
      request.dataConnector = paraquetConnector;
      request.dataConnectorType = DataConnectorType.Parquet;
      request.dataSourceType = dataSourceType;
      request.configMappedCols = configMappedCols;
      request.targetDataFarm = targetDataFarm;
      request.isAutoMapApplied = isAutoMapApplied;
      request.isClearMapButtonClicked = isClearMapButtonClicked;
      request.ingestConfigGUID = ingestConfigGUID;
      request.selectedIngestFarmGUID = selectedIngestFarmGUID;
      request.mapLibraryType = mapLibraryType;
      return request;
    }

  
    static newFileConnectorColumnRequest(
      fileConnector: FileDataConnectorInfo,
      dataSourceType: DataSourceType,
      organizationId: number, configMappedCols: ConfigColumnMap[], targetDataFarm: number, isAutoMapApplied: boolean, isClearMapButtonClicked: boolean, ingestConfigGUID: string, selectedIngestFarmGUID: string, mapLibraryType: string): GetColumnsRequest {
      const request = new GetColumnsRequest();
      request.organizationId = organizationId;
      request.dataConnector = fileConnector;
      request.dataConnectorType = DataConnectorType.Text;
      request.dataSourceType = dataSourceType;
      request.configMappedCols = configMappedCols;
      request.targetDataFarm = targetDataFarm;
      request.isAutoMapApplied = isAutoMapApplied;
      request.isClearMapButtonClicked = isClearMapButtonClicked;
      request.ingestConfigGUID = ingestConfigGUID;
      request.selectedIngestFarmGUID = selectedIngestFarmGUID;
      request.mapLibraryType = mapLibraryType;
      return request;
    }

  
    static newDatabaseConnectorColumnRequest(
      dbConnector: DatabaseConnectorInfo,
      dataSourceType: DataSourceType,
      organizationId: number, configMappedCols: ConfigColumnMap[], targetDataFarm: number, isAutoMapApplied: boolean, isClearMapButtonClicked: boolean, ingestConfigGUID: string, selectedIngestFarmGUID: string, mapLibraryType: string): GetColumnsRequest {
      const request = new GetColumnsRequest();
      request.organizationId = organizationId;
      request.dataConnector = dbConnector;
      request.dataConnectorType = DataConnectorType.Database;
      request.databaseType = DatabaseType.SQL;
      request.dataSourceType = dataSourceType;
      request.configMappedCols = configMappedCols;
      request.targetDataFarm = targetDataFarm;
      request.isAutoMapApplied = isAutoMapApplied;
      request.isClearMapButtonClicked = isClearMapButtonClicked;
      request.ingestConfigGUID = ingestConfigGUID;
      request.selectedIngestFarmGUID = selectedIngestFarmGUID;
      request.mapLibraryType = mapLibraryType;

      return request;
    }

    static newOracleConnectorColumnRequest(
      dbConnector: OracleDataConnectorInfo,
      dataSourceType: DataSourceType,
      organizationId: number, configMappedCols: ConfigColumnMap[], targetDataFarm: number, isAutoMapApplied: boolean, isClearMapButtonClicked: boolean, ingestConfigGUID: string, selectedIngestFarmGUID: string, mapLibraryType: string): GetColumnsRequest {
      const request = new GetColumnsRequest();
      request.organizationId = organizationId;
      request.dataConnector = dbConnector;
      request.dataConnectorType = DataConnectorType.Database;
      request.databaseType = DatabaseType.Oracle;
      request.dataSourceType = dataSourceType;
      request.configMappedCols = configMappedCols;
      request.targetDataFarm = targetDataFarm;
      request.isAutoMapApplied = isAutoMapApplied;
      request.isClearMapButtonClicked = isClearMapButtonClicked;
      request.ingestConfigGUID = ingestConfigGUID;
      request.selectedIngestFarmGUID = selectedIngestFarmGUID;
      request.mapLibraryType = mapLibraryType;
      return request;
    }
    
    static newVerticaConnectorColumnRequest(
      dbConnector: OracleDataConnectorInfo,
      dataSourceType: DataSourceType,
      organizationId: number, configMappedCols: ConfigColumnMap[], targetDataFarm: number, isAutoMapApplied: boolean, isClearMapButtonClicked: boolean, ingestConfigGUID: string, selectedIngestFarmGUID: string, mapLibraryType: string): GetColumnsRequest {
      const request = new GetColumnsRequest();
      request.organizationId = organizationId;
      request.dataConnector = dbConnector;
      request.dataConnectorType = DataConnectorType.Database;
      request.databaseType = DatabaseType.Oracle;
      request.dataSourceType = dataSourceType;
      request.configMappedCols = configMappedCols;
      request.targetDataFarm = targetDataFarm;
      request.isAutoMapApplied = isAutoMapApplied;
      request.isClearMapButtonClicked = isClearMapButtonClicked;
      request.ingestConfigGUID = ingestConfigGUID;
      request.selectedIngestFarmGUID = selectedIngestFarmGUID;
      request.mapLibraryType = mapLibraryType;
      return request;
    }
    static newMySqlConnectorColumnRequest(
      dbConnector: MySqlDataConnectorInfo,
      dataSourceType: DataSourceType,
      organizationId: number, configMappedCols: ConfigColumnMap[], targetDataFarm: number, isAutoMapApplied: boolean, isClearMapButtonClicked: boolean, ingestConfigGUID: string, selectedIngestFarmGUID: string, mapLibraryType: string): GetColumnsRequest {
      const request = new GetColumnsRequest();
      request.organizationId = organizationId;
      request.dataConnector = dbConnector;
      request.dataConnectorType = DataConnectorType.Database;
      request.databaseType = DatabaseType.MySql;
      request.dataSourceType = dataSourceType;
      request.configMappedCols = configMappedCols;
      request.targetDataFarm = targetDataFarm;
      request.isAutoMapApplied = isAutoMapApplied;
      request.isClearMapButtonClicked = isClearMapButtonClicked;
      request.ingestConfigGUID = ingestConfigGUID;
      request.selectedIngestFarmGUID = selectedIngestFarmGUID;
      request.mapLibraryType = mapLibraryType;
      return request;
    }
}

export class MapColumnsRequest {
  refineryConfigID: String = ""
  farmTypeID: String = ""

  constructor(refineryConfigID: string, farmTypeID: string ) {
      this.refineryConfigID = refineryConfigID;
      this.farmTypeID = farmTypeID;
  }
}